import React, { useEffect, useState } from "react";
import "./terms.scss";
import { tickIcon } from "../../source";

const termListData = [
  // {
  //   mainTitle: "Ganesh Chaturthi Contest Terms & Conditions",
  //   termList: [
  //     {
  //       title: "Social Media <br/><br/> Announcement Post",
  //       description: [
  //         "<strong>Format - Carousel</strong>",
  //         "<strong>Pinned Post on Taste Masters Instagram page</strong>",
  //         "Communication - Prasad Ko Banao Mahaprasad in English",
  //         `Post Talking Points
  //         <ul>
  //           <li>How to participate</li>
  //           <li>What products to use while making the recipe videos (Kesar Milk Masala & Saffron)</li>
  //           <li>Contest Duration</li>
  //           <li>Gratification details</li>
  //         </ul>
  //         `,
  //       ],
  //     },
  //     {
  //       title: "Influencer Shout-out",
  //       description: [
  //         "Reach out to Madhura and other Marathi creators who can do a shout-out video for this contest specifically.",
  //         "Get ad usage rights for 15 days from Madhura.",
  //         "Communication - Prasad Ko Banao Mahaprasad in English",
  //       ],
  //     },
  //     {
  //       title: "Website",
  //       description: [
  //         "A homepage banner with copy (Terms & Conditions applied)",
  //       ],
  //     },

  //   ],
  // },
  {
    mainTitle: "Terms & Conditions",
    termList: [
      // {
      //   title: "Ganesh Chaturthi Contest Terms & Conditions",
      //   description: [
      //     "<strong>New Contest Period:</strong> 20th August to 5th September.",
      //     "<strong>Mandatory Products:</strong> Each recipe video must use both Saffron and Kesar Milk Masala.",
      //     "<strong>Multiple Submissions:</strong> If a participant uploads 2 videos in a single month, only the video with the higher views will be considered.",
      //     "<strong>Previously Uploaded Videos:</strong> If a participant has already uploaded a video using Saffron & Kesar Milk Masala before 20th August, the entry will only be valid if they re-register and upload a new video during the GC campaign period.",
      //   ],
      // },
      // {
      //   title: "Revised Milestones",
      //   description: [
      //     `
      //     <div class="table_wrapper">
      //       <table class="mil_table">
      //         <thead>
      //           <tr>
      //             <th>Video Views</th>
      //             <th>Gratification</th>
      //           </tr>
      //         </thead>
      //         <tbody>
      //           <tr>
      //             <td>10,000</td>
      //             <td>INR 750 worth Amazon Voucher</td>
      //           </tr>
      //           <tr>
      //             <td>25,000</td>
      //             <td>INR 3000 worth Amazon Voucher</td>
      //           </tr>
      //           <tr>
      //             <td>50,000</td>
      //             <td>INR 7500 worth Home Appliances(Approx)</td>
      //           </tr>
      //           <tr>
      //             <td>2,00,000 +</td>
      //             <td>INR 30,000 worth Home Appliances(Approx)</td>
      //           </tr>
      //         </tbody>
      //       </table>
      //     </div>
      //     `,
      //   ],
      // },

      // {
      //   title: "Diwali Contest Terms & Conditions",
      //   description: [
      //     "<strong>New Contest Period:</strong> 15th October to 23rd October",
      //     "<strong>Mandatory Products:</strong> Participants must submit a video entry featuring an original, vegetarian recipe that uses any Everest Spices",
      //     "To enter the contest, participants must include the hashtag <strong>#Tasteof DiwaliwithEverest</strong> in their submission.",
      //     "<strong>Previously Uploaded Videos:</strong> If a participant has already uploaded a video using Everest Spices before 15th October, the entry will only be valid if they re-register and upload a new video during the Diwali contest period.",
      //     "Any artificial inflation of views or engagement through bots or third-party services is strictly prohibited and will result in disqualification.",
      //   ],
      // },
      // {
      //   title: "Revised Milestones",
      //   description: [
      //     `
      //     <div class="table_wrapper">
      //       <table class="mil_table">
      //         <thead>
      //           <tr>
      //             <th>Video Views</th>
      //             <th>Gratification</th>
      //           </tr>
      //         </thead>
      //         <tbody>
      //           <tr>
      //             <td>10,000</td>
      //             <td>INR 750 worth Amazon Voucher</td>
      //           </tr>
      //           <tr>
      //             <td>25,000</td>
      //             <td>INR 3000 worth Amazon Voucher</td>
      //           </tr>
      //           <tr>
      //             <td>50,000</td>
      //             <td>INR 7500 worth Home Appliances (Approx)</td>
      //           </tr>
      //           <tr>
      //             <td>2,00,000 +</td>
      //             <td>INR 30,000 worth Home Appliances (Approx)</td>
      //           </tr>
      //         </tbody>
      //       </table>
      //     </div>
      //     `,
      //   ],
      // },

      {
        title: "Eligibility",
        description: [
          "Open to Indian residents aged 18+.",
          "Must follow @everest_tastemasters on Instagram.",
          "Everest brand partners/collaborators are not eligible.",
        ],
      },
      {
        title: "Registration",
        description: [
          "Register by the 10th of each month at tastemasters.everestfoods.com.",
          "Re-registration is required every month.",
          "Only the first 1,000 valid registrations per month will be accepted.",
        ],
      },
      {
        title: "Content Guidelines",
        description: [
          "Submit your video only after registration.",
          "The video must feature Everest Spices product in the cooking process",
          "Keep Everest Spice product clearly visible near the dish throughout the video",
          "Display of other brands is strictly prohibited",
          "Inappropriate, offensive, or low-quality content will be disqualified.",
          "Participants must not infringe any copyrights, trademarks, or other intellectual property rights.",
          "Content must not misrepresent or defame Everest Spices",
          "If multiple videos are posted, only the one with the most views will be considered.",
          "You are not permitted to upload or post video content using multiple accounts. Any attempt to bypass this by using duplicate or alternative accounts will result in disqualification for that month",
        ],
      },
      {
        title: "View Count & Validity",
        description: [
          "Views will be counted up to 5:00 PM on the 10th of each month.",
          "Everest reserves the right to verify views and disqualify any suspicious activity.",
          "Everest’s decision on winners is final and binding.",
        ],
      },
      {
        title: "Rewards",
        description: [
          "First-time valid video posters get a ₹200 Amazon voucher, limited to first 1,000 valid entries each month.",
          "Each user can claim each gratification only once.",
          "An iPhone can be won only once per user in a year; future milestones will qualify for alternate top prizes.",
          "No combining of multiple gratifications allowed.",
        ],
      },
      {
        title: "Usage Rights",
        description: [
          "Everest may reuse, repost, or promote your content across its marketing platforms.",
        ],
      },
      {
        title: "General Conditions",
        description: [
          "Bots, fake accounts, or multiple entries by the same person will lead to disqualification.",
          "If any contestant is suspected of using bots or engaging in artificial promotion of their video, Everest reserves the right to reject or suspend the video entry at any time, without prior notice.",
          "By participating, you accept that Everest’s decisions are final and legally binding in all matters related to the program.",
        ],
      },
    ],
  },
];

const TermsAndConditions = (props) => {
  // const [termsData, setTermsData] = useState({
  //   participationConsent: false,
  //   termsConsent: false,
  // });
  // const [termsErrors, setTermsErrors] = useState({});
  // const [isSubmitting, setIsSubmitting] = useState(false);

  // const validateTerms = () => {
  //   const errors = {};
  //   if (!termsData.participationConsent) {
  //     errors.participationConsent =
  //       "You must agree to participate in Everest Taste Masters";
  //   }
  //   if (!termsData.termsConsent) {
  //     errors.termsConsent = "You must accept the terms and conditions";
  //   }
  //   return errors;
  // };

  // const handleTermsChange = (e) => {
  //   const { name, checked } = e.target;
  //   setTermsData((prev) => ({
  //     ...prev,
  //     [name]: checked,
  //   }));
  //   // Clear error when checkbox is checked
  //   if (checked && termsErrors[name]) {
  //     setTermsErrors((prev) => ({
  //       ...prev,
  //       [name]: undefined,
  //     }));
  //   }
  // };

  // const handleTermsSubmit = async () => {
  //   const errors = validateTerms();
  //   if (Object.keys(errors).length > 0) {
  //     setTermsErrors(errors);
  //     return;
  //   }

  //   setIsSubmitting(true);
  //   try {
  //     await props.onSubmit(termsData);
  //   } catch (error) {
  //     console.error("Submission error:", error);
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section className={`terms_sec1`}>
        <div className="my_container">
          <div className="term_content">
            {/* <p className="notice">Terms & Conditions</p> */}
            <div className="term_content_box">
              {termListData?.map((item, index) => (
                <div className="terms_list_box" key={index}>
                  <p className="notice">{item?.mainTitle}</p>
                  {item?.termList?.map((data, i) => (
                    <div className="term_data_box" key={`terms-${i}`}>
                      <p
                        className="heading"
                        dangerouslySetInnerHTML={{ __html: data?.title }}
                      ></p>
                      <div className="term_points">
                        {data?.description?.map((desc, index) => (
                          <div className="title_flex">
                            <img
                              width={24}
                              height={18}
                              src={tickIcon}
                              alt="tick"
                              className="tick_icon"
                              loading="lazy"
                            />
                            <h3
                              className="term_title"
                              dangerouslySetInnerHTML={{ __html: desc }}
                              key={`description-${index}`}
                            ></h3>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
              {/* <div className="checkbox_wrap">
                <h5 className="heading">Consent & Agreement</h5>
                <div className="consent_checks">
                  <div className="form-group form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="participationConsent"
                      name="participationConsent"
                      checked={termsData.participationConsent}
                      onChange={handleTermsChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="participationConsent"
                    >
                      I agree to participate in Everest Taste Masters and create
                      content using Everest Spices.
                    </label>
                  </div>
                  {termsErrors.participationConsent && (
                    <div className="error_message" style={{ color: "red" }}>
                      {termsErrors.participationConsent}
                    </div>
                  )}
                  <div className="form-group form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="termsConsent"
                      name="termsConsent"
                      checked={termsData.termsConsent}
                      onChange={handleTermsChange}
                    />
                    <label className="form-check-label" htmlFor="termsConsent">
                      I understand the terms & conditions, and I consent to
                      providing the above information for the purpose of this
                      program.
                    </label>
                  </div>
                  {termsErrors.termsConsent && (
                    <div className="error_message" style={{ color: "red" }}>
                      {termsErrors.termsConsent}
                    </div>
                  )}
                </div>
              </div> */}
              {/* <div className="cta_wrapper">
                <button
                  className="common_cta"
                  onClick={handleTermsSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsAndConditions;
